// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onedrive-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.onedrive-modal-content {
  background-color: #fff;
  border-radius: 12px;
  width: 90%;
  max-width: 650px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
}

.onedrive-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.onedrive-modal-header h2 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #333;
}

.onedrive-modal-close {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.onedrive-modal-close:hover {
  background-color: #f0f0f0;
  color: #333;
}

.onedrive-modal-body {
  padding: 24px;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.onedrive-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #5616ea;
}

.onedrive-loading p {
  margin-top: 16px;
  color: #666;
}

.onedrive-no-connections {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
}

.onedrive-no-connections p {
  margin: 8px 0;
  color: #333;
  font-size: 1rem;
}

.onedrive-no-connections .onedrive-hint {
  color: #666;
  font-size: 0.875rem;
  margin-bottom: 24px;
}

.onedrive-account-selector {
  margin-bottom: 16px;
}

.onedrive-add-account-link {
  color: #5616ea;
  font-size: 0.875rem;
  cursor: pointer;
  display: inline-block;
  margin-top: 8px;
}

.onedrive-add-account-link:hover {
  text-decoration: underline;
}

.onedrive-file-browser {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  min-height: 300px;
  max-height: 400px;
}

.onedrive-back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background-color: #f5f5f5;
  border: none;
  border-bottom: 1px solid #e0e0e0;
  cursor: pointer;
  color: #333;
  font-size: 0.9rem;
}

.onedrive-back-button:hover {
  background-color: #e8e8e8;
}

.onedrive-breadcrumb {
  padding: 10px 16px;
  background-color: #fafafa;
  border-bottom: 1px solid #e0e0e0;
  font-size: 0.8rem;
  color: #666;
}

.onedrive-loading-files {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 48px;
  color: #5616ea;
}

.onedrive-empty-folder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #666;
  text-align: center;
}

.onedrive-empty-folder .onedrive-hint {
  font-size: 0.8rem;
  color: #999;
  margin-top: 8px;
}

.onedrive-file-list {
  flex: 1 1;
  overflow-y: auto;
  padding: 8px 0;
}

.onedrive-file-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s;
}

.onedrive-file-item:hover {
  background-color: #f5f5f5;
}

.onedrive-file-item.selected {
  background-color: #f3eaff;
}

.onedrive-file-item.folder {
  cursor: pointer;
}

.onedrive-file-icon {
  margin-right: 12px;
  font-size: 1.1rem;
}

.onedrive-file-icon.folder-icon {
  color: #5616ea;
}

.onedrive-file-icon.file-icon {
  color: #666;
}

.onedrive-file-name {
  flex: 1 1;
  font-size: 0.9rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.onedrive-selected-count {
  padding: 10px 16px;
  background-color: #f3eaff;
  color: #5616ea;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
  border-top: 1px solid #e0d4f7;
}

.onedrive-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/components/OneDrivePickerModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B","sourcesContent":[".onedrive-modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n.onedrive-modal-content {\r\n  background-color: #fff;\r\n  border-radius: 12px;\r\n  width: 90%;\r\n  max-width: 650px;\r\n  max-height: 85vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.onedrive-modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 16px 24px;\r\n  border-bottom: 1px solid #e0e0e0;\r\n}\r\n\r\n.onedrive-modal-header h2 {\r\n  margin: 0;\r\n  font-size: 1.25rem;\r\n  font-weight: 600;\r\n  display: flex;\r\n  align-items: center;\r\n  color: #333;\r\n}\r\n\r\n.onedrive-modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.25rem;\r\n  color: #666;\r\n  cursor: pointer;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.onedrive-modal-close:hover {\r\n  background-color: #f0f0f0;\r\n  color: #333;\r\n}\r\n\r\n.onedrive-modal-body {\r\n  padding: 24px;\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.onedrive-loading {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.onedrive-loading p {\r\n  margin-top: 16px;\r\n  color: #666;\r\n}\r\n\r\n.onedrive-no-connections {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px 24px;\r\n  text-align: center;\r\n}\r\n\r\n.onedrive-no-connections p {\r\n  margin: 8px 0;\r\n  color: #333;\r\n  font-size: 1rem;\r\n}\r\n\r\n.onedrive-no-connections .onedrive-hint {\r\n  color: #666;\r\n  font-size: 0.875rem;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n.onedrive-account-selector {\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.onedrive-add-account-link {\r\n  color: #5616ea;\r\n  font-size: 0.875rem;\r\n  cursor: pointer;\r\n  display: inline-block;\r\n  margin-top: 8px;\r\n}\r\n\r\n.onedrive-add-account-link:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.onedrive-file-browser {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n  min-height: 300px;\r\n  max-height: 400px;\r\n}\r\n\r\n.onedrive-back-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 10px 16px;\r\n  background-color: #f5f5f5;\r\n  border: none;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  cursor: pointer;\r\n  color: #333;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.onedrive-back-button:hover {\r\n  background-color: #e8e8e8;\r\n}\r\n\r\n.onedrive-breadcrumb {\r\n  padding: 10px 16px;\r\n  background-color: #fafafa;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  font-size: 0.8rem;\r\n  color: #666;\r\n}\r\n\r\n.onedrive-loading-files {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 12px;\r\n  padding: 48px;\r\n  color: #5616ea;\r\n}\r\n\r\n.onedrive-empty-folder {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 48px;\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n.onedrive-empty-folder .onedrive-hint {\r\n  font-size: 0.8rem;\r\n  color: #999;\r\n  margin-top: 8px;\r\n}\r\n\r\n.onedrive-file-list {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 8px 0;\r\n}\r\n\r\n.onedrive-file-item {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 10px 16px;\r\n  cursor: pointer;\r\n  transition: background-color 0.15s;\r\n}\r\n\r\n.onedrive-file-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n.onedrive-file-item.selected {\r\n  background-color: #f3eaff;\r\n}\r\n\r\n.onedrive-file-item.folder {\r\n  cursor: pointer;\r\n}\r\n\r\n.onedrive-file-icon {\r\n  margin-right: 12px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.onedrive-file-icon.folder-icon {\r\n  color: #5616ea;\r\n}\r\n\r\n.onedrive-file-icon.file-icon {\r\n  color: #666;\r\n}\r\n\r\n.onedrive-file-name {\r\n  flex: 1;\r\n  font-size: 0.9rem;\r\n  color: #333;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.onedrive-selected-count {\r\n  padding: 10px 16px;\r\n  background-color: #f3eaff;\r\n  color: #5616ea;\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  text-align: center;\r\n  border-top: 1px solid #e0d4f7;\r\n}\r\n\r\n.onedrive-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 16px;\r\n  padding-top: 16px;\r\n  border-top: 1px solid #e0e0e0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
